module.exports = __webpack_public_path__ + "static/media/trace.964ae36f.less";